import { useState } from "react";
import styled from "styled-components";
import { Button, Dialog } from "@blueprintjs/core";
import { Tooltip } from "@mantine/core";

import { Code } from "@components/Code";
import { Subheading } from "@components/Headings";

import { BundleAddressString } from "@pages/editor/stores";

const BrandButton = styled(Button)`
  && {
    height: 36px;
    font-size: var(--global-font-size-m);
  }
`;

export const DialogBody = styled.div`
  padding: 20px;
  width: 600px;
`;

export const RunInCLIButton = ({
  snippetId,
  isUnsaved,
}: {
  snippetId: BundleAddressString;
  isUnsaved: boolean;
}) => {
  const disabled = snippetId === "new" || isUnsaved;
  const [isOpen, setIsOpen] = useState(false);
  const runInCLIButton = (
    <BrandButton
      intent={"none"}
      onClick={() => {
        setIsOpen(true);
      }}
      disabled={disabled}
    >
      Run in CLI
    </BrandButton>
  );

  return (
    <div>
      {disabled ? (
        <Tooltip position="top" label="Save to run in CLI" withArrow>
          <div>{runInCLIButton}</div>
        </Tooltip>
      ) : (
        runInCLIButton
      )}
      <Dialog
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        title="Run in CLI"
      >
        <DialogBody>
          <Subheading style={{ marginTop: 0 }}>
            To run this rule locally:
          </Subheading>
          <p>Step 1: install the CLI tool</p>
          <Code copyable>pip install semgrep</Code>
          <p style={{ marginTop: "12px" }}>Step 2: Scan a code directory</p>
          <Code copyable>{`semgrep --config ${snippetId}`}</Code>
        </DialogBody>
      </Dialog>
    </div>
  );
};
